<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <el-card shadow="never" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>我的资金</span>
        </div>
        <el-row type="flex" align="middle" justify="center">
          <el-col :span="6" class="colStyle">
            <div>待结算</div>
            <div>{{ waitSettleAmount }}</div>
          </el-col>
          <el-col :span="6" class="colStyle" v-if=" $store.state.roleId == '2125410685723869666'" >
            <div>代理余额</div>
            <div>{{ balance }}</div>
          </el-col>
          <el-col :span="6" class="colStyle" v-if="$store.state.roleId == '1125070436338499584'" >
            <div>余额(充值 + 代收结算 - 代付 - 提现)</div>
            <div>{{ balance }}</div>
          </el-col>

          <el-col :span="6" class="colStyle">
            <div>冻结金额</div>
            <div>{{ freezeBalance }}</div>
          </el-col>
          <el-col :span="6" class="colStyle">
            <div>可用余额(余额 - 冻结)</div>
            <div>{{ availableBalance }}</div>
          </el-col>

          <el-col :span="6">
            <el-button :loading="loading" type="primary" size="mini" @click="handleRefresh"
            >刷新</el-button>
            <br/>
            <el-button type="primary" size="mini" plain 
              style="margin-top: 10px"
              @click="handleRecharge"
              v-if="$store.state.roleId == '1125070436338499584'"
              >充值</el-button
            >
            <br />
            <el-button
              type="warning"
              size="mini"
              @click="handleWithdraw"
              plain
              style="margin-top: 10px"
              v-if="$store.state.roleId == '1125070436338499584' || $store.state.roleId == '2125410685723869666'"
              >提现</el-button
            >
          </el-col>
        </el-row>
      </el-card>
      <el-tabs v-model="activeName">
        <el-tab-pane label="充值记录" name="recharge">
          <recharge
            v-if="$store.state.roleId == '1125070436338499584'"
          ></recharge>
          <recharge1 v-else></recharge1>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="withdraw">
          <withdraw
            v-if="$store.state.roleId == '1125070436338499584'"
          ></withdraw>
          <withdraw1 v-else></withdraw1>
        </el-tab-pane>
      </el-tabs>
    </div>
    <recharge-dialog
      :is-show-recharge-dialog.sync="isShowRechargeDialog"
    ></recharge-dialog>
    <withdraw-dialog
      :is-show-withdraw-dialog.sync="isShowWithdrawDialog"
      :balance="balance"
      :freezeBalance="freezeBalance"
      :availableBalance="availableBalance"
    ></withdraw-dialog>
  </div>
</template>

<script>
import Recharge from "./components/recharge.vue";
import WithDraw from "./components/withdraw.vue";
import Recharge1 from "./components/recharge1.vue";
import WithDraw1 from "./components/withdraw1.vue";
import RechargeDialog from "./components/RechargeDialog.vue";
import WithdrawDialog from "./components/WithdrawDialog.vue";
export default {
  components: {
    recharge: Recharge,
    withdraw: WithDraw,
    recharge1: Recharge1,
    withdraw1: WithDraw1,
    RechargeDialog: RechargeDialog,
    WithdrawDialog: WithdrawDialog,
  },
  data() {
    return {
      activeName: "recharge",
      isShowRechargeDialog: false,
      isShowWithdrawDialog: false,
      balance: 0,
      freezeBalance: 0,
      waitSettleAmount: 0,
      availableBalance: 0,
      loading: false,

    };
  },
  created() {
    this.handleRefresh()
  },
  methods: {
    handleRefresh() {
      this.loading = true
      this.balance = '...',
      this.freezeBalance = '...',
      this.waitSettleAmount = '...',
      this.availableBalance = '...',

      this.axios.get("/merchant/getAccountFund", { params: {} }).then((res) => {
      if (res.code === 200) {
        this.balance = this.$formatter.FenToYuan(
          null,
          null,
          res.data.balance,
          null
        );
        this.freezeBalance = this.$formatter.FenToYuan(
          null,
          null,
          res.data.freezeBalance,
          null
        );
        this.waitSettleAmount = this.$formatter.FenToYuan(
          null,
          null,
          res.data.waitSettleAmount,
          null
        );

        this.availableBalance = this.$formatter.FenToYuan(
          null,
          null,
          res.data.availableBalance,
          null
        );



      }
    });
    this.loading = false

    },
    handleRecharge() {
      this.isShowRechargeDialog = true;
    },
    handleWithdraw() {
      this.isShowWithdrawDialog = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.colStyle {
  text-align: center;
  line-height: 34px;
}
</style>